import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import { RadioTemplateType } from './lu-radio.model';

@Component({
	templateUrl: './lu-radio.component.html',
	styleUrls: ['./lu-radio.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class LuRadioComponent extends FieldType {
	RadioTemplateType = RadioTemplateType;
	defaultOptions = {
		templateOptions: {
			templateType: RadioTemplateType.DEFAULT,
			options: [],
			formCheck: 'default' // 'default' | 'inline'
		}
	};

	selectOption(value: unknown) {
		if (!this.formControl.disabled && !this.to.disabled && !this.to.readonly) {
			this.formControl.setValue(value);
		}
	}

	handleKeydown(event: KeyboardEvent, value: unknown) {
		if (event.key === 'Enter' || event.key === ' ') {
			event.preventDefault();
			this.selectOption(value);
		}
	}
}
